<script setup lang="ts">
import merge from 'lodash-es/merge';
import { useWebsitesStore } from '#layers/cms/app/pages/cms/management/websites/_runtime/stores/websites';

interface FormSettings
{
    settings: any;
}

defineOptions({
    name: 'WidgetIntDocumentsSearchSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('int_documents');
const defaults = ref<any>({
    pageId: null,
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const current = computed((): CurrentWebsite =>
{
    return useWebsitesStore().current;
});

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            pageId: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    await wait(() => current.value.website);
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <div>
        <IdeoFormGroup :label="$t('[[[Strona z modułu baza dokumentów]]]')" :invalid-feedback="form.$errors.first('settings.pageId')" :state="form.$errors.state('settings.pageId')" required>
            <EditoPageSelector
                v-model="form.settings.pageId"
                :module="module"
                label=""
                :website="false"
                :preview="false"
                class="mb-0"
            />
        </IdeoFormGroup>
    </div>
</template>
